import React, { PureComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { Tag } from 'components/cosmos';
import { ErrorCard } from 'components/errorCard';
import { LoaderCard } from 'components/loaderCard';
import { I18n, translate } from 'components/translate';
import get from 'lodash/get';
import { inject } from 'mobx-react';
import { STATUS_BADGE_PROPS } from 'modules/salesManager/campaigns/constants';
import PropTypes from 'prop-types';

import CampaignsService from '../../../CampaignsService';

import './CampaignListItem.scss';

class CampaignListItem extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    numberOfSales: PropTypes.object,
    isMobile: PropTypes.bool,
    campaignId: PropTypes.string
  };

  get showableLoader() {
    const { numberOfSales } = this.props;

    return numberOfSales.loading;
  }

  get showableError() {
    const { numberOfSales } = this.props;

    return !this.showableLoader && numberOfSales.error;
  }

  get showableContent() {
    return !this.showableLoader && !this.showableError;
  }

  handleSalesRefresh = () => {
    const { campaignId } = this.props;

    CampaignsService.fetchNumberOfSales(campaignId);
  };

  renderType = () => (
    <div className="campaign_list_item__type">
      <I18n
        label={`campaign.types.${this.props.type}`}
        data-test="campaign-type"
      />
    </div>
  );

  renderStatus = () => {
    const { status, t } = this.props;
    const statusBadgeProps = STATUS_BADGE_PROPS[status];

    if (!statusBadgeProps) {
      return null;
    }

    return (
      <Tag variation={statusBadgeProps.variation} className="_ml-2">
        {t(statusBadgeProps.label)}
      </Tag>
    );
  };

  renderName = () => (
    <div data-test="campaign-name" className="campaign_list_item__name">
      {this.props.name}
    </div>
  );

  renderSales = () => (
    <div data-test="campaign-sales" className="campaign_list_item__sales">
      {this.showableContent ? (
        get(this.props, 'numberOfSales.value', 0)
      ) : (
        <>
          {this.showableLoader && (
            <LoaderCard
              data-test="number-sales-loader"
              text={this.props.t('select.loadingMessage')}
              iconSize={16}
              className="campaign_list_item__sales_loader"
            />
          )}
          {this.showableError && (
            <ErrorCard
              data-test="number-sales-error"
              text={this.props.t('general.retry')}
              iconSize={16}
              className="campaign_list_item__sales_error"
              onClick={this.handleSalesRefresh}
            />
          )}
        </>
      )}
    </div>
  );

  renderMobile = () => (
    <div data-test="mobile-item">
      <header className="campaign_list_item__header">
        {this.renderType()}
        {this.renderStatus()}
      </header>
      <div className="campaign_list_item__body">{this.renderName()}</div>
      {this.props.numberOfSales && (
        <footer
          data-test="number-of-sales-mobile"
          className="campaign_list_item__footer"
        >
          <span className="campaign_list_item__sales_label">
            <FontAwesomeIcon
              icon={['fal', 'circle-dollar']}
              className="_mr-2"
            />
            <I18n label="general.sales" />
          </span>
          {this.renderSales()}
        </footer>
      )}
    </div>
  );

  renderDesktop = () => (
    <div data-test="desktop-item">
      <header className="campaign_list_item__header">
        {this.renderName()}
        {this.renderStatus()}
      </header>
      <div className="campaign_list_item__body">
        <div className="campaign_list_item__body_col_1">
          <div className="campaign_list_item__type_label">
            <I18n label="campaign.campaign_type" />
          </div>
          {this.renderType()}
        </div>
        {this.props.numberOfSales && (
          <div data-test="number-of-sales-desktop">
            <div className="campaign_list_item__sales_label">
              <I18n label="campaign.total_sales" />
            </div>
            {this.renderSales()}
          </div>
        )}
      </div>
    </div>
  );

  render() {
    const { isMobile } = this.props;
    const className = classnames('campaign_list_item', this.props.className);

    return (
      <div className={className}>
        {isMobile ? this.renderMobile() : this.renderDesktop()}
      </div>
    );
  }
}

export default inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))(translate()(CampaignListItem));

export { CampaignListItem };
